import { GetAssessmentResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../services/core-api-service";

export const getCurrentAssessment = async (): Promise<GetAssessmentResult> => {
    return api.assessments.getCurrentAssessment();
}